<template>
  <div
    class="py-3 px-3 min-w-60 flex flex-col gap-3 bg-pure-white rounded border border-slate-400"
  >
    <div class="flex items-center justify-between gap-2">
      <BlTextBody2 :text="title" />
      <div
        v-if="title === 'Scheduled sessions'"
        class="px-2 h-6 flex items-center gap-2 rounded-full cursor-pointer"
        :style="{ backgroundColor: '#F4F3FF' }"
        @click="
          rescheduledSwitch =
            rescheduledSwitch === 'session' ? 'credit' : 'session'
        "
      >
        <BlIcon icon="swap" class="h-4 w-4" />
        <BlTextBody3
          :text="`${rescheduledSwitch === 'session' ? 'credit' : 'session'}s`"
          class="text-light-purple capitalize"
        />
      </div>
    </div>
    <!--  -->
    <div class="flex items-center justify-between gap-3 truncate">
      <div v-if="title === 'Current balance'" class="flex gap-2">
        <BlTextSubtitle1
          :text="currentCenter.currency_sym"
          class="text-slate-500"
        />
        <BlTextTitle3
          :text="priceFormats(currentBalance)"
          :class="[
            currentBalance < 0 ? 'text-red-cherry' : 'text-dark-purple-100'
          ]"
        />
      </div>
      <div
        v-else-if="title === 'Scheduled sessions'"
        class="flex items-center gap-2"
      >
        <BlTextTitle3
          v-if="rescheduledSwitch === 'session'"
          :text="totalSessions || 0"
          :class="[
            totalSessions < 0 ? 'text-red-cherry' : 'text-dark-purple-100'
          ]"
        />
        <BlTextTitle3
          v-if="rescheduledSwitch === 'credit'"
          :text="totalCredits || 0"
          :class="[
            totalCredits < 0 ? 'text-red-cherry' : 'text-dark-purple-100'
          ]"
        />
        <BlTextBody3
          :text="`${rescheduledSwitch}(s)`"
          class="text-slate-600 truncate"
        />
      </div>
      <div v-else class="flex items-center gap-2 truncate">
        <BlTextTitle3 :text="totalAvailableCredits" class="text-lime-500" />
        <BlTextBody3 text="credit(s)" class="text-slate-600 truncate" />
      </div>

      <div v-if="usePanel">
        <BlInputButton
          type="outlined"
          icon="chevron-right"
          dense
          class="w-7 h-7 bg-slate-200 rounded-full"
          @clicked="$emit('open-panel')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { displayPrice } from "@/plugins/helper.js";

import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "CreditDetails",
  components: {
    BlTextTitle3,
    BlTextSubtitle1,
    BlTextBody2,
    BlTextBody3,
    BlIcon,
    BlInputButton
  },
  props: {
    title: String,
    //
    expiringSoon: { type: Number | null },
    available: { type: Number | null },
    used: { type: Number | null },
    //
    totalSessions: { type: Number, default: 0 },
    totalCredits: { type: Number, default: 0 },
    currentBalance: { type: Number, default: 0 },
    usePanel: { type: Boolean, default: false }
    // @open-panel
  },
  data() {
    return {
      rescheduledSwitch: "session" // session | credit
    };
  },
  computed: {
    ...mapGetters(["currentCenter"]),
    totalAvailableCredits() {
      if (this.expiringSoon === null && this.available === null) {
        return `∞`;
      }

      const arr = [this.expiringSoon, this.available];
      const sum = (this.expiringSoon || 0) + (this.available || 0);
      if (arr.includes(null)) {
        if (sum > 0) return `∞ + ${sum}`;
        return `∞`;
      }
      return sum;
    }
  },
  methods: {
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentCenter.currency_settings;
      return this.displayPrice({ settings, price });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/creditTransaction/CreditDetails.vue